'use client';

import GlassSurface from './GlassSurface';

type NavGlassItemProps = {
  active?: boolean;
  children: React.ReactNode;
  // default = current desktop behavior
  variant?: 'default' | 'mobile';
};

export default function NavGlassItem({ active, children, variant = 'default' }: NavGlassItemProps) {
  // ----------------------------
  // ORIGINAL DESKTOP BEHAVIOR
  // ----------------------------
  if (variant === 'default') {
    // ACTIVE item = inner glass highlight
    if (active) {
      return (
        <GlassSurface data-component-id="src/components/ui/NavGlassItem.tsx:20:8" data-component-path="src/components/ui/NavGlassItem.tsx" data-component-line="20" data-component-end-line="35" data-component-file="NavGlassItem.tsx" data-component-name="GlassSurface" data-component-content="%7B%22elementName%22%3A%22GlassSurface%22%2C%22className%22%3A%22px-2.5%20flex%20items-center%20justify-center%20text-white%20font-medium%20text-sm%22%7D"
          width="auto"
          height={36}
          borderRadius={18}
          blur={10}
          opacity={0.85}
          brightness={60}
          backgroundOpacity={0.25}
          distortionScale={-80}
          redOffset={3}
          greenOffset={8}
          blueOffset={12}
          className="px-2.5 flex items-center justify-center text-white font-medium text-sm"
        >
          {children}
        </GlassSurface>
      );
    }

    // INACTIVE item = simple link (unchanged for laptop)
    return (
      <span data-component-id="src/components/ui/NavGlassItem.tsx:41:6" data-component-path="src/components/ui/NavGlassItem.tsx" data-component-line="41" data-component-end-line="43" data-component-file="NavGlassItem.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22px-2.5%20py-1%20text-sm%20text-gray-200%20hover%3Atext-cyan-400%20transition%22%7D" className="px-2.5 py-1 text-sm text-gray-200 hover:text-cyan-400 transition">
        {children}
      </span>
    );
  }

  // ----------------------------
  // MOBILE VARIANT: always glass
  // ----------------------------
  const commonClass = 'px-4 flex items-center justify-center text-sm whitespace-nowrap transition';

  if (active) {
    return (
      <GlassSurface data-component-id="src/components/ui/NavGlassItem.tsx:54:6" data-component-path="src/components/ui/NavGlassItem.tsx" data-component-line="54" data-component-end-line="69" data-component-file="NavGlassItem.tsx" data-component-name="GlassSurface" data-component-content="%7B%22elementName%22%3A%22GlassSurface%22%7D"
        width="auto"
        height={36}
        borderRadius={18}
        blur={10}
        opacity={0.9}
        brightness={65}
        backgroundOpacity={0.3}
        distortionScale={-80}
        redOffset={3}
        greenOffset={8}
        blueOffset={12}
        className={`${commonClass} text-white font-medium`}
      >
        {children}
      </GlassSurface>
    );
  }

  return (
    <GlassSurface data-component-id="src/components/ui/NavGlassItem.tsx:74:4" data-component-path="src/components/ui/NavGlassItem.tsx" data-component-line="74" data-component-end-line="89" data-component-file="NavGlassItem.tsx" data-component-name="GlassSurface" data-component-content="%7B%22elementName%22%3A%22GlassSurface%22%7D"
      width="auto"
      height={32}
      borderRadius={16}
      blur={8}
      opacity={0.7}
      brightness={55}
      backgroundOpacity={0.18}
      distortionScale={-60}
      redOffset={2}
      greenOffset={5}
      blueOffset={8}
      className={`${commonClass} text-gray-200 hover:text-cyan-400`}
    >
      {children}
    </GlassSurface>
  );
}
